export default __webpack_public_path__ + "static/media/id-verified.b2333dcb.jpg";